<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('letrex.edit.subtitle') }}
        </span>
        <h3 class="page-title d-inline">{{ $t('letrex.edit.title') }}</h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-letrex-new' }"
        >
          {{ $t('letrex.edit.button.add') }}
        </router-link>
      </d-col>
    </d-row>
    <letrex-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import LetrexPage from '../components/LetrexPage.vue';

export default {
  name: 'letrex-edit',
  components: {
    LetrexPage,
  },
  methods: {
    ...mapActions(['getLetrex']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getLetrex(this.$route.params.puzzleId);
    }
  },
};
</script>
